import { CorsWorkerService as Worker } from '../../Services/CorsWorkerService';

const createSocketConnectionWorker = async () => {
  return new Worker(new URL('./SocketConnectionWorker.ts', import.meta.url), {
    type: 'module',
    name: 'socket-connection-worker',
  }).createWorker();
};

export const SocketConnectionWorker = await createSocketConnectionWorker();
